export default "__VITE_ASSET__CINzxk6H__"